import React from 'react';
import { Damage } from '@/types';
import { Tag } from 'antd';

const normalizePartNumber = (value?: string) =>
  (value || '').trim().toLowerCase();

export const getDamageActionTreeData = (
  damageLines: Damage[] = [],
  partNumber?: string,
) => {
  const normalizedPartNumber = normalizePartNumber(partNumber);

  return damageLines
    .filter((o) => o.actions.length > 0)
    .map((o) => ({
      label: `${o.damageAreaDesc} - ${o.damagePartDesc} - ${o.repairActionDesc}`,
      value: o.id,
      children: o.actions.map((a) => {
        const actionLabel = a.labourType || a.flatRateDesc;
        const isUsed =
          normalizedPartNumber.length > 0 &&
          (a.parts || []).some(
            (part) =>
              normalizePartNumber(part.partNumber) === normalizedPartNumber,
          );

        return {
          label: isUsed ? (
            <>
              <Tag color="orange" className="me-2">
                Exists
              </Tag>
              {actionLabel}
            </>
          ) : (
            actionLabel
          ),
          value: a.id,
        };
      }),
    }));
};
